import { Box } from '@mui/material';
import { Button } from '@ovComponents/2-component/button/button';
import { Form } from '@ovComponents/2-component/form/form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const WorkflowCompletionForm = (
  props: React.ComponentProps<typeof Form> & {
    submitButtonProps?: Omit<React.ComponentProps<typeof Button>, 'loading'>;
    buttonFooter?: React.ReactNode;
    showSubmitButton?: boolean;
  },
) => {
  const { t } = useTranslation('shared');
  const {
    submitButtonProps = { label: t('submit') },
    buttonFooter,
    showSubmitButton = true,
    ...rest
  } = props;
  const [disabled, setDisabled] = useState(false);

  const submit = async () => {
    setDisabled(true);
    try {
      await rest.onSubmit();
    } finally {
      setDisabled(false);
    }
  };

  return (
    <Form {...rest} onSubmit={submit}>
      {rest.children}
      <Box display='flex' justifyContent='flex-end'>
        {buttonFooter}
        {showSubmitButton && (
          <Button
            {...submitButtonProps}
            sx={{ mt: 3, textAlign: 'center' }}
            type='submit'
            disabled={disabled || submitButtonProps.disabled}
          />
        )}
      </Box>
    </Form>
  );
};
